import _ from 'lodash';

import z from 'app/common/z';
import fetch, { fetchJson } from 'app/common/fetch';

const Data = {
  getEmailQueryParams() {
    // this isn't really good - touching magical global data
    const params = new z.useful.QueryString().object;
    const queryParams = {};
    const interestingParams = ['email', 'checksum'];
    _.each(interestingParams, param => {
      if (params[param]) {
        queryParams[param] = params[param];
      }
    });
    return queryParams;
  },

  getDecodeMessageQueryParams() {
    // this isn't really good - touching magical global data
    const params = new z.useful.QueryString().object;
    const queryParams = {};
    const interestingParams = [
      ['email_id', 'email_id'],
      ['payload_checksum', 'checksum'],
    ];
    _.each(interestingParams, param => {
      if (params[param[0]]) {
        queryParams[param[1]] = params[param[0]];
      }
    });
    return queryParams;
  },

  getSubscriptionsUrl() {
    return fetch.url(
      `${z.cfg.api}/accounts/me/subscriptions`,
      this.getEmailQueryParams()
    );
  },

  getNotificationsUrl() {
    return fetch.url(
      `${z.cfg.api}/accounts/me/notifications`,
      this.getEmailQueryParams()
    );
  },

  subscriptions() {
    return fetchJson(this.getSubscriptionsUrl());
  },

  notifications() {
    return fetchJson(this.getNotificationsUrl());
  },

  patchSubscriptions(subscriptions) {
    return fetch(this.getSubscriptionsUrl(), {
      method: 'PATCH',
      body: JSON.stringify(subscriptions),
    }).then(fetch.success);
  },

  patchNotifications(notifications) {
    return fetch(this.getNotificationsUrl(), {
      method: 'PATCH',
      body: JSON.stringify(notifications),
    }).then(fetch.success);
  },

  decodeMessage(payload) {
    return fetchJson(
      fetch.url(`${z.cfg.api}/accounts/me/decode_message`, {
        ...this.getDecodeMessageQueryParams(),
        payload,
      })
    );
  },
};

export default Data;
